/* 
/* ロード完了時のアニメーション
*/
$(window).on('load', function () {
    $('#loading').addClass('loaded');
});
// ブラウザバック時にonloadが発火しない問題
window.addEventListener('pageshow', function () {
    $('#loading').addClass('loaded');
});


/* 
/* ハンバーガーメニューの処理
*/
$(".openbtn").on("click", function () {
    $(this).toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $("body").toggleClass('fixed');
});

$(".nav-img__wrap").on("click", function () {
    $(".openbtn").toggleClass('active');
    $(".sp-menu-drawer").toggleClass('active');
    $(".sp-nav-wrap").toggleClass('active');
    $("body").toggleClass('fixed');
});


/* 
/* 別ドメインの場合の別窓遷移
*/
const links = document.querySelectorAll(".top-learn__wrap a");
for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
    }
}


/* 
/* bfcache対策
*/
/*
window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        // bfcache発動時の処理
        window.location.reload();
    }
});
*/

/* 
/* 画面遷移前のアニメーション
*/
/*
$('a').on('click', function (event) {
    var link = $(this).attr('href');
    var target = $(this).attr('target');

    if (target === '_blank') {
        return;
    }

    event.preventDefault();
    $('#loading').removeClass('loaded');
    setTimeout(function () {
        location.href = link;
    }, 250);
});
*/


/* 
/* 時間差処理
*/
$(window).on('load', function () {
    // 下層FVメインタイトル
    setTimeout(function () {
        $('.sub-fv-wrapper .title h1').addClass('active');
    }, 700);
    // 下層FVサブタイトル
    setTimeout(function () {
        $('.sub-fv-wrapper .title .sub-title').addClass('active');
    }, 800);
    // FLお問合せバナー
    setTimeout(function () {
        $('.fl-bnr-01').addClass('active');
    }, 1600);
});


/* 
/* TOPに戻る
*/
$(function () {
    var pagetop = $('#page-top');
    var flbnr = $('#fl-bnr__sp');
    pagetop.hide();
    flbnr.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            pagetop.fadeIn();
            flbnr.fadeIn();
        } else {
            pagetop.fadeOut();
            flbnr.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body, html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});


/* 
/* モーダル用
*/
$('.facility-map__wrap .img__wrap .text01').click(function () {
    $('.bg-black').addClass('active');
    $('#con01.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.facility-map__wrap .img__wrap .text02').click(function () {
    $('.bg-black').addClass('active');
    $('#con02.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.facility-map__wrap .img__wrap .text03').click(function () {
    $('.bg-black').addClass('active');
    $('#con03.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.facility-map__wrap .img__wrap .text04').click(function () {
    $('.bg-black').addClass('active');
    $('#con04.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.facility-map__wrap .img__wrap .text05').click(function () {
    $('.bg-black').addClass('active');
    $('#con05.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.add-map-img__wrap .text06').click(function () {
    $('.bg-black').addClass('active');
    $('#con06.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.add-map-img__wrap .text07').click(function () {
    $('.bg-black').addClass('active');
    $('#con07.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.add-map-img__wrap .text08').click(function () {
    $('.bg-black').addClass('active');
    $('#con08.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.add-map-img__wrap .text09').click(function () {
    $('.bg-black').addClass('active');
    $('#con09.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.staff10').click(function () {
    $('.bg-black').addClass('active');
    $('#con10.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.staff11').click(function () {
    $('.bg-black').addClass('active');
    $('#con11.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.staff12').click(function () {
    $('.bg-black').addClass('active');
    $('#con12.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.staff13').click(function () {
    $('.bg-black').addClass('active');
    $('#con13.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.staff14').click(function () {
    $('.bg-black').addClass('active');
    $('#con14.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.modal-1').click(function () {
    $('.bg-black').addClass('active');
    $('#n1.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.modal-2').click(function () {
    $('.bg-black').addClass('active');
    $('#n2.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.modal-3').click(function () {
    $('.bg-black').addClass('active');
    $('#n3.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.modal-4').click(function () {
    $('.bg-black').addClass('active');
    $('#n4.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.modal-5').click(function () {
    $('.bg-black').addClass('active');
    $('#n5.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.sdgs-1').click(function () {
    $('.bg-black').addClass('active');
    $('#m1.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.sdgs-2').click(function () {
    $('.bg-black').addClass('active');
    $('#m2.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.sdgs-3').click(function () {
    $('.bg-black').addClass('active');
    $('#m3.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.sdgs-4').click(function () {
    $('.bg-black').addClass('active');
    $('#m4.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.sdgs-5').click(function () {
    $('.bg-black').addClass('active');
    $('#m5.con__wrap').addClass('active');
    $("body").addClass('fixed');
});

$('.close__wrap, .bg-black').click(function () {
    $('.bg-black').removeClass('active');
    $("body").removeClass('fixed');
    $('#con01.con__wrap, #con02.con__wrap, #con03.con__wrap, #con04.con__wrap, #con05.con__wrap, #con06.con__wrap, #con07.con__wrap, #con08.con__wrap, #con09.con__wrap, #con10.con__wrap, #con11.con__wrap ,#con12.con__wrap, #con13.con__wrap ,#con14.con__wrap').removeClass('active');
});

$('.close__wrap, .bg-black').click(function () {
    $('.bg-black').removeClass('active');
    $("body").removeClass('fixed');
    $('#n1.con__wrap,#n2.con__wrap,#n3.con__wrap,#n4.con__wrap,#n5.con__wrap,#m1.con__wrap,#m2.con__wrap,#m3.con__wrap,#m4.con__wrap,#m5.con__wrap').removeClass('active');
});